<template>
  <div :class="`container_${mode}`" class="update-bullet_container">
    <div :class="`back_${mode}`" class="update-bullet_container_back"></div>
    <img :src="avatar" class="update-bullet_container_avatar" />
    <div class="update-bullet_container_info">
      <div class="update-bullet_container_info_top">
        <div
          class="update-bullet_container_info_top_left"
          style="justify-content: start;"
        >
          <div
            :class="`nickName_${mode}`"
            class="update-bullet_container_info_top_left_name"
          >
            {{ nickNameText }}
          </div>
          <no-ssr>
            <star-rating
              v-if="targetType === '37'"
              :read-only="true"
              :show-rating="false"
              :rating="score"
              :star-size="10"
            />
          </no-ssr>

          <div
            v-if="targetType === '17' && roleName !== '业主'"
            :class="`member_${mode}`"
            class="member"
          >
            {{ roleName }}
          </div>

          <div
            v-if="targetType === '17' && roleName === '业主'"
            :class="`owner_${mode}`"
            class="owner"
          >
            {{ roleName }}
          </div>
        </div>

        <div
          :class="`time_${mode}`"
          class="update-bullet_container_info_top_right"
        >
          {{ timeText }}
        </div>
      </div>
      <div
        :class="`eventContent_${mode}`"
        class="update-bullet_container_info_bottom"
      >
        <!-- {{ eventContent }} -->
        {{ eventContent }}
      </div>
    </div>
    <div
      :style="
        targetType === '37'
          ? 'background-color: #39C87F'
          : 'background-color: #FFCF66'
      "
      class="left-bar"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'normal'
    },
    eventContent: {
      type: String,
      default: ''
    },
    nickName: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'evaluate'
    }, // owner member evaluate
    roleName: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    targetType: {
      type: String,
      default: ''
    },
    score: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      a: 1
    }
  },
  computed: {
    nickNameText() {
      const name = this.nickName
      return name.length > 10 ? name.slice(0, 10) + '...' : name
    },
    timeText() {
      let text = ''
      if (this.targetType === '17') text = ' 更新'
      if (this.targetType === '37') text = ' 评价'
      return `${this.time}${text}`
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
:deep(.icon-star1::before){
  content: '\E511';
  color: #d6d6d6;
}
.member {
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding: 0px 6px;
  white-space: nowrap;
}
.owner {
  background: #ffcf66;
  color: #444444;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding: 0px 6px;
  white-space: nowrap;
}
.update-bullet_container_back {
  content: '';
  z-index: -20;
  // width: 100%;
  // height: 72px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  width: 100%;
}
.update-bullet_container {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  border-radius: 6px;
  // border: 1px solid rgba(255, 201, 76, 0.25);
  border-right: 0px;
  max-width: 400px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 69px;
  > div {
    z-index: 30;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &_avatar {
    z-index: 30;
    border-radius: 40px;
    width: 40px;
    margin-left: 14px;
    margin-right: 15px;
    height: 40px;
  }
}
.left-bar {
  z-index: 1000;
  position: absolute;
  width: 2px;
  border-radius: 10px;
  height: 20px;
  background-color: yellow;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
}
.update-bullet_container_info {
  max-width: 330px;
  padding-right: 15px;
  &_bottom {
    max-width: 330px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-top: 3px;
    line-clamp: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &_top {
    max-width: 330px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    &_right {
      font-size: 12px;
      line-height: 20px;
      white-space: nowrap;
      flex-shrink: 0;
    }
    &_left {
      align-items: center;
      flex-shrink: 1;
      display: flex;
      margin-right: 10px;
      &_name {
        font-weight: 500;
        margin-right: 6px;
        font-size: 15px;
        display: block !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.eventContent_dark {
  color: #ffffff;
}
.eventContent_normal {
  color: #444444;
}
.time_dark {
  color: #ffffff;
  opacity: 0.45;
}
.time_normal {
  color: #d6d6d6;
}

.member_dark {
  background: rgba(255, 207, 102, 0.2);
  color: #ffcf66;
}

.owner_dark {
  background: #ffcf66;
  color: #444444;
}
.owner_normal {
  background: #00bfd1;
  color: #fff;
}
.member_normal {
  background: rgba(0, 191, 209, 0.1);
  color: #00bfd1;
}
.nickName_normal {
  color: #9b9b9b;
}
.nickName_dark {
  color: #ffffff;
  opacity: 0.65;
}
.font_color_normal {
  color: #9b9b9b;
}
.font_color_dark {
  color: #fff;
  opacity: 0.65;
}
.back_normal {
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.back_dark {
  background: linear-gradient(270deg, #000000 0%, rgba(77, 69, 46, 0.8) 100%);
  backdrop-filter: blur(3px);
}
.container_dark {
  border: 1px solid rgba(255, 201, 76, 0.15);
  border-right: 0px;
}
.container_normal {
  border: 0px;
}
</style>
